import script from "./IncludingMajors.vue?vue&type=script&lang=ts&setup=true"
export * from "./IncludingMajors.vue?vue&type=script&lang=ts&setup=true"

import "./IncludingMajors.vue?vue&type=style&index=0&id=29eaefed&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29eaefed"]])

export default __exports__